export default function()
{
    return this.$store.state.now;
}